




















import Vue, { PropType } from 'vue'
import gConfig from '@/config/google'
import { Position } from '@/components/Map/types'

export default Vue.extend({
  name: 'HeaderImage',
  props: {
    name: String,
    shortName: String,
    subVendorName: String,
    position: Object as PropType<Position>,
    loading: Boolean
  },
  computed: {
    image (): string { return this.loading ? '' : this.getImage() }
  },
  methods: {
    close (): void { this.$router.push({ path: `/${this.$route.name}` }) },
    getImage (): string {
      const lat = this.position?.lat || ''
      const lng = this.position?.lng || ''
      const center = `${lat},${lng}`
      return `https://maps.googleapis.com/maps/api/staticmap?center=${center}&markers=${center}&zoom=18&&size=600x300&maptype=roadmap&key=${gConfig.apiKey}`
    }
  }
})
